import { useField } from 'formik';
import {
  Typeahead,
  TypeaheadProps,
} from '@antimatterhq/ui/components/typeahead';

export type FormTypeaheadProps = TypeaheadProps & {
  name: string;
  'data-testid'?: string;
};

export const FormTypeahead = ({ name, ...props }: FormTypeaheadProps) => {
  const [field, meta] = useField(name);
  const hasError = meta.touched && !!meta.error && !!name;
  const variant = hasError ? 'error' : 'default';
  // eslint-disable-next-line
  props = { ...field, ...props };
  return (
    <div
      className="max-w-form"
      data-testid={`form-typeahead-container-${name}`}
    >
      <Typeahead
        name={name}
        variant={variant}
        data-testid={`form-typeahead-${name}`}
        {...props}
      />
    </div>
  );
};
